<div class="validation-group-new">
    @if (warnings.length || infos.length) {
        <skl-validation-icon
            [sklHintbox]="warningsHintbox"
            [violation]="'warning'">
            <counter class="validation-icon-new__counter">{{ warningsCount }}</counter>
        </skl-validation-icon>
    }
    @if (errors.length) {
        <skl-validation-icon
            [sklHintbox]="errorsHintbox"
            [violation]="'error'">
            <counter class="validation-icon-new__counter">{{ errorsCount }}</counter>
        </skl-validation-icon>
    }
</div>